

/* eslint-disable react/prop-types */
/* eslint-disable camelcase */

'use client';

import * as React from 'react';
import { ChevronLeftIcon, ChevronRightIcon } from 'lucide-react';
import { DayPicker } from 'react-day-picker';

import { cn } from '@/lib/utils';
import { buttonVariants } from '@/global/base/button';

// TODO This component was built with react-day-picker 8
// However, due to conflicts, I had to upgrade it to version 9
// This causes some conflicts so I went with a hacky solution
// See full migration guide: https://daypicker.dev/upgrading#7-update-your-custom-components

function Calendar({
    className,
    classNames,
    showOutsideDays = true,
    ...props
}: React.ComponentProps<typeof DayPicker>) {
    return (
        <DayPicker
            showOutsideDays={showOutsideDays}
            className={cn('p-3', className)}
            classNames={{
                months: 'flex flex-col gap-2 relative',
                month: 'flex flex-col gap-4',
                month_caption: 'flex justify-center pt-1 relative items-center w-full',
                caption_label: 'text-sm font-medium',
                nav: 'flex items-center gap-1 absolute h-7 w-full z-10',
                button_previous: cn(
                    buttonVariants({ variant: 'outline' }),
                    'h-7 w-7 bg-transparent p-0 opacity-50 hover:opacity-100',
                    'absolute left-1'
                ),
                button_next: cn(
                    buttonVariants({ variant: 'outline' }),
                    'h-7 w-7 bg-transparent p-0 opacity-50 hover:opacity-100',
                    'absolute right-1'
                ),
                month_grid: 'w-full border-collapse space-x-1',
                weekdays: 'flex',
                weekday:
          'text-muted-foreground rounded-md w-8 font-normal text-[0.8rem]',
                week: 'flex w-full mt-2',
                day: cn(
                    buttonVariants({ variant: 'ghost' }),
                    'relative p-0 text-center text-sm focus-within:relative focus-within:z-20 [&:has([aria-selected])]:bg-accent [&:has([aria-selected].day-range-end)]:rounded-r-md',
                    props.mode === 'range'
                        ? '[&:has(>.day-range-end)]:rounded-r-md [&:has(>.day-range-start)]:rounded-l-md first:[&:has([aria-selected])]:rounded-l-md last:[&:has([aria-selected])]:rounded-r-md'
                        : '[&:has([aria-selected])]:rounded-md',
                    'h-8'
                ),
                day_button: cn('size-8 p-0 font-normal aria-selected:opacity-100'),
                range_start: 'day-range-start',
                range_end: 'day-range-end',
                selected:
          'bg-primary text-primary-foreground hover:bg-primary hover:text-primary-foreground focus:bg-primary focus:text-primary-foreground',
                today:
          'bg-accent text-accent-foreground hover:bg-primary hover:text-primary-foreground',
                outside: ' text-muted-foreground aria-selected:text-muted-foreground',
                disabled: 'text-muted-foreground opacity-50',
                range_middle:
          'aria-selected:bg-accent aria-selected:text-accent-foreground',
                hidden: 'invisible',
                ...classNames
            }}
            components={{
                Chevron: (props) => {
                    if (props.orientation === 'left') {
                        return <ChevronLeftIcon {...props} />;
                    }

                    return <ChevronRightIcon {...props} />;
                }
            }}
            {...props}
        />

    );
}

export { Calendar };
